{
  "title": "Quick article",
  "newQuickArticleTitle": "Create new quick article"
}
